// import React, { useState, useRef } from "react";

// import img1 from "../image/gallary1.png";
// import img2 from "../image/project1.png";
// import img3 from "../image/project2.png";
// import img4 from "../image/project3.png";
// import img5 from "../image/project4.png";
// import img6 from "../image/project5.png";
// import img7 from "../image/gallery-interior-01.jpeg";
// import img8 from "../image/gallery-interior-02.jpeg";
// import img9 from "../image/gallery-interior-03.jpeg";
// import img10 from "../image/gallery-interior-04.jpeg";
// import img11 from "../image/gallery-interior-05.jpeg";
// import img12 from "../image/gallery-interior-06.jpeg";
// import img13 from "../image/gallery-interior-07.jpeg";
// import img14 from "../image/gallery-interior-08.jpeg";
// import img15 from "../image/gallery-interior-09.jpeg";
// import img16 from "../image/gallery-interior-10.jpeg";
// import img17 from "../image/gallery-interior-11.jpeg";
// import img18 from "../image/gallery-interior-12.jpeg";
// import img19 from "../image/gallery-interior-13.jpeg";


// const images = [
//   {
//     src: img1,
//     title: "Ongoing Residential Construction",
//     subtitle:
//       "A multi-storey residential project currently under construction with strong structural planning and quality materials.",
//   },
//   {
//     src: img2,
//     title: "Modern Elevation Design",
//     subtitle:
//       "A beautifully designed home exterior combining modern architecture with elegant façade detailing.",
//   },
//   {
//     src: img3,
//     title: "Contemporary Apartment Design",
//     subtitle:
//       "Well-planned residential building with efficient space utilization and modern architectural aesthetics.",
//   },
//   {
//     src: img4,
//     title: "Completed Interior Work",
//     subtitle:
//       "A finished living space featuring premium materials, smart layouts, and a modern aesthetic touch.",
//   },
//   {
//     src: img5,
//     title: "Custom Living Room Design",
//     subtitle:
//       "A stylish TV unit and living area designed for comfort, functionality, and a clean modern look.",
//   },
//   {
//     src: img6,
//     title: "Functional Storage Solutions",
//     subtitle:
//       "Custom-designed wardrobes and storage units maximizing space while maintaining elegance.",
//   },
//   {
//     src: img7,
//     title: "Warm Living Room Interior",
//     subtitle:
//       "A modern living room with wooden wall detailing, a sleek TV unit, and smart space separation.",
//   },
//   {
//     src: img8,
//     title: "Elegant Lounge Setup",
//     subtitle:
//       "A comfortable lounge area designed with custom furniture, premium flooring, and a refined media wall.",
//   },
//   {
//     src: img9,
//     title: "Modern Bedroom Wardrobe",
//     subtitle:
//       "A clean bedroom setup with sliding wardrobe panels, a round mirror feature, and calm color accents.",
//   },
//   {
//     src: img10,
//     title: "Mirror Feature Wall",
//     subtitle:
//       "A minimal feature wall with a round mirror detail that adds depth, light, and visual balance.",
//   },
//   {
//     src: img11,
//     title: "Vibrant Study Corner",
//     subtitle:
//       "A compact study area with bold cabinetry, open shelving, and a functional work desk design.",
//   },
//   {
//     src: img12,
//     title: "Bright Bedroom Design",
//     subtitle:
//       "A fresh bedroom layout with a sliding wardrobe, soft ceiling detailing, and colorful bedding accents.",
//   },
//   {
//     src: img13,
//     title: "Contemporary Modular Kitchen",
//     subtitle:
//       "A glossy modular kitchen with efficient storage, clean counters, and a practical cooking layout.",
//   },
//   {
//     src: img14,
//     title: "Decorative Console Unit",
//     subtitle:
//       "A stylish console and wall panel arrangement finished with elegant decor and soft color contrast.",
//   },
//   {
//     src: img15,
//     title: "Entryway Storage Design",
//     subtitle:
//       "A welcoming entrance area with built-in seating storage, blinds, and a custom finished door.",
//   },
//   {
//     src: img16,
//     title: "Dining Area Interior",
//     subtitle:
//       "A refined dining space with marble finish flooring, soft lighting, and a balanced furniture layout.",
//   },
//   {
//     src: img17,
//     title: "Glossy Kitchen Interior",
//     subtitle:
//       "A modern modular kitchen with glossy green cabinets, glass shutters, and a clean worktop layout.",
//   },
//   {
//     src: img18,
//     title: "TV Unit With Kitchen View",
//     subtitle:
//       "A sleek TV panel finished with soft curves, built-in storage, and a connected open kitchen layout.",
//   },
//   {
//     src: img19,
//     title: "Open Living TV Wall",
//     subtitle:
//       "A bright living area with a custom TV unit, ceiling lighting, and a polished modern interior finish.",
//   },
// ];

// export default function Gallery() {
//   const [index, setIndex] = useState(0);

//   // Drag refs
//   const startX = useRef(0);
//   const isDragging = useRef(false);

//   // Navigation
//   const prevSlide = () => {
//     setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//   };

//   const nextSlide = () => {
//     setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));  
//   };

//   // Position Logic 
//   const getPosition = (i) => {
//     const total = images.length;
//     let diff = i - index;

//     if (diff > total / 2) diff -= total;
//     if (diff < -total / 2) diff += total;

//     if (diff === 0) return "active";
//     if (diff === -1) return "left";
//     if (diff === 1) return "right";

//     return "hidden";
//   };

//   //  Start
//   const handleStart = (clientX) => {
//     startX.current = clientX;
//     isDragging.current = true;
//   };

//   //  Move instant response
//   const handleMove = (clientX) => {
//     if (!isDragging.current) return;

//     const diff = startX.current - clientX;

//     if (diff > 30) {
//       nextSlide();
//       isDragging.current = false;
//     } else if (diff < -30) {
//       prevSlide();
//       isDragging.current = false;
//     }
//   };

//   //  End
//   const handleEnd = () => {
//     isDragging.current = false;
//   };

//   return (
//     <div className="gallery container-fluid">

//       {/*  Dynamic Heading */}
//       <div className="gallery-header text-center">
//         <h2 className="gallery-title">{images[index].title}</h2>
//         <p className="gallery-subtitle">{images[index].subtitle}</p>
//       </div>

//       {/*  Slider */}
//       <div
//         className="slider"
//         onMouseDown={(e) => handleStart(e.clientX)}
//         onMouseMove={(e) => handleMove(e.clientX)}
//         onMouseUp={handleEnd}
//         onMouseLeave={handleEnd}
//         onTouchStart={(e) => handleStart(e.touches[0].clientX)}
//         onTouchMove={(e) => handleMove(e.touches[0].clientX)}
//         onTouchEnd={handleEnd}
//       >
//         {images.map((img, i) => {
//           const position = getPosition(i);

//           return (
//             <div key={i} className={`card ${position}`}>
//               <img src={img.src} alt={img.title} />
//             </div>
//           );
//         })}
//       </div>

//       {/*  Buttons */}
//       <div className="slider-controls">
//         <button className="nav-btn left" onClick={prevSlide}>
//           ←
//         </button>
//         <button className="nav-btn right" onClick={nextSlide}>
//           →
//         </button>
//       </div>

//     </div>
//   );
// }

import React, { useState, useRef } from "react";

import img1 from "../image/gallary444.png";
import img2 from "../image/gallary-img22.png";
import img3 from "../image/gallary-img33.png";

const images = [

 {
    src: img2,
    title: "Modern Luxury Villa Project, Mapusa, Goa",
    subtitle:
      "A luxurious villa featuring contemporary architecture, natural stone finishes, and a bright open courtyard designed for peaceful living.",
  },

  // {
  //   src: img1,
  //   title: "Airport Theme commercial Space",
  //   subtitle:
  //     "Modern airport architecture with grand arches, premium lighting, and contemporary façade detailing.",
  // },

  {
  src: img1,
  // title: "Rajmata City Residences",
   title: "Rajmata City at Latur",
  subtitle:
    "An urban residential landmark with layered façades, generous balconies, and curated amenity spaces for contemporary family life.",
},
 
  {
    src: img3,
    // title: "Apartment Building Design",
    title: "Proposed residential Bunglow at Aurangabad",
    subtitle:
      "A premium 6BHK bungalow proposal with crisp external geometry, large terraces, and an interior plan focused on luxury comfort.",
  },
];

export default function Gallery() {
  const [index, setIndex] = useState(0);

  const startX = useRef(0);
  const isDragging = useRef(false);

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const getPosition = (i) => {
    const total = images.length;
    let diff = i - index;

    if (diff > total / 2) diff -= total;
    if (diff < -total / 2) diff += total;

    if (diff === 0) return "active";
    if (diff === -1) return "left";
    if (diff === 1) return "right";

    return "hidden";
  };

  const handleStart = (clientX) => {
    startX.current = clientX;
    isDragging.current = true;
  };

  const handleMove = (clientX) => {
    if (!isDragging.current) return;

    const diff = startX.current - clientX;

    if (diff > 30) {
      nextSlide();
      isDragging.current = false;
    } else if (diff < -30) {
      prevSlide();
      isDragging.current = false;
    }
  };

  const handleEnd = () => {
    isDragging.current = false;
  };

  return (
    <div className="gallery container-fluid">
      {/* Heading */}
      <div className="gallery-header text-center">
        <h2 className="gallery-title">{images[index].title}</h2>
        <p className="gallery-subtitle">{images[index].subtitle}</p>
      </div>

      {/* Slider */}
      <div
        className="slider"
        onMouseDown={(e) => handleStart(e.clientX)}
        onMouseMove={(e) => handleMove(e.clientX)}
        onMouseUp={handleEnd}
        onMouseLeave={handleEnd}
        onTouchStart={(e) => handleStart(e.touches[0].clientX)}
        onTouchMove={(e) => handleMove(e.touches[0].clientX)}
        onTouchEnd={handleEnd}
      >
        {images.map((img, i) => {
          const position = getPosition(i);

          return (
            <div key={i} className={`card ${position}`}>
              <img src={img.src} alt={img.title} />
            </div>
          );
        })}
      </div>

      {/* Navigation Buttons */}
      <div className="slider-controls">
        <button className="nav-btn left" onClick={prevSlide}>
          ←
        </button>

        <button className="nav-btn right" onClick={nextSlide}>
          →
        </button>
      </div>
    </div>
  );
}
